<template>
  <div class="toolhead-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('toolhead_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-tools</v-icon>{{$t('profile.tool.toolheads')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ToolHeadFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
                <template slot="item.toolHeadSubs" slot-scope="{ item }">
                  <ul>
                    <li v-for="_item in item['toolHeadSubs']" :key="_item.id">
                      {{ _item.id }}
                    </li>
                  </ul>
                </template>
          <template slot="item.created" slot-scope="{ item }">
            {{ formatDateTime(item['created'], 'long') }}
          </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ToolHeadFilterForm from '../../components/toolhead/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ToolHeadList',
  servicePrefix: 'ToolHead',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    ToolHeadFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.tool.name'), value: 'name' },
        { text: this.$t('profile.tool.version'), value: 'version' },
        { text: this.$t('profile.tool.machine'), value: 'machine.name' },
        { text: this.$t('profile.tool.parent'), value: 'parent.name' },
        { text: this.$t('global.archive'), value: 'archive'},
        { text: this.$t('global.createdat'), value: 'created'},
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['created'], sortDesc : [true]}
    };
  },
  computed: {
    ...mapGetters('toolhead', {
      items: 'list'
    }),
    ...mapFields('toolhead', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('toolhead', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
